import { AdditionalFields } from '../domain/entities/inspirationalTemplate';
import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './inspirationalTemplateMap.en';

export const INSPIRATIONAL_TEMPLATE_MAP: Record<string, AdditionalFields> = {
  'b991864c-cd05-498d-85e2-03459fdeb6ec': {
    backgroundColor: '#F3FFE0',
    shortDescription:
      'Confira os efeitos dinâmicos de movimento que este site de página única pode oferecer.',
    features: [
      'Vídeo transparente',
      'Animação de hover',
      'Letreiro',
      'Código personalizado',
      'Grade CSS',
      'Biblioteca de ativos para download',
    ],
    inspirationalAssets:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].thumbnailUrl,
  },
  'd674b741-2412-4260-af3f-c5f0e964fcd5': {
    backgroundColor: '#F4EDFF',
    shortDescription:
      'Embarque em uma viagem ao espaço com animações de rolagem e seções dinâmicas giratórias.',
    features: [
      'Animação de rolagem',
      'Animação de loop',
      'Rolagem horizontal',
      'Efeitos de hover',
      'CSS personalizado',
    ],
    inspirationalAssets:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].thumbnailUrl,
  },
  '8de718ac-8cc4-4b69-88ab-4d92920c37a2': {
    backgroundColor: '#FFE8E4',
    shortDescription:
      'Compartilhe ideias com letreiros dinâmicos e dê movimento ao seu conteúdo.',
    features: [
      'Letreiro',
      'Animação de rolagem',
      'Animação de loop',
      'Animação de entrada',
      'Efeitos de rolagem de background',
      'Grade CSS',
    ],
    inspirationalAssets:
      EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].thumbnailUrl,
  },
  '50d5ca42-112a-466a-aca2-fd8bc927a965': {
    backgroundColor: '#E2FFE2',
    shortDescription:
      'Inspire-se nos efeitos de rolagem e animações deste site para ONGs.',
    features: [
      'Animação de rolagem',
      'Animação de loop',
      'Animação de entrada',
      'Vídeo transparente',
      'Grade CSS',
      'Pilha',
    ],
    inspirationalAssets:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].thumbnailUrl,
  },
  '31ec1ed2-9432-46e2-8175-5e4ccab9b5b9': {
    backgroundColor: '#FFE6F1',
    shortDescription:
      'Use o scrollytelling para dar vida a fatos, estatísticas e números.',
    features: [
      'Animação de rolagem',
      'Animação de loop',
      'Animação de entrada',
      'Letreiro',
      'Gradiente de background',
      'Efeitos de rolagem de background',
    ],
    inspirationalAssets:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].thumbnailUrl,
  },
  '498fe8fb-46ba-45a5-9346-3bb5b1c9f61c': {
    backgroundColor: '#E6F2FF',
    shortDescription:
      'Desvende os mistérios do zodíaco com este site de astrologia moderno e envolvente.',
    features: [
      'Efeitos de mouse',
      'Posição sticky',
      'Rolagem horizontal',
      'Animação de rolagem',
      'Código personalizado',
    ],
    inspirationalAssets:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssets,
    inspirationalAssetsV2:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssetsV2,
    thumbnailUrl: EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].thumbnailUrl,
  },
};
